import { useState, useCallback } from 'react';

import { useAuth, useOpen } from '@/hooks';
import { getHasSeenIntroVideo, setHasSeenIntroVideo } from '@/utils/storage';
import { AppContent } from '@/components/layouts';
import { AppLoader } from '@/components/shared/AppLoader';

export const App = () => {
  const isOpen = useOpen();
  const [showIntroVideo, setShowIntroVideo] = useState(
    () => !getHasSeenIntroVideo()
  );

  useAuth();

  const handleIntroClose = useCallback(() => {
    setShowIntroVideo(false);
    setHasSeenIntroVideo();
  }, []);

  if (!isOpen) {
    return <AppLoader />;
  }

  return (
    <AppContent
      showIntroVideo={showIntroVideo}
      onIntroClose={handleIntroClose}
    />
  );
};

export default App;
